<template>
<div class="common-framework-container">
  <div class="wrap-top" :style="style">
    <div class="header">
      <div class="icon-logo">
        <img src="../../../assets/logo.png" alt="" @click="jumpTolink('home')">
        <span class="title">{{this.name}}</span>
      </div>
      <div class="link-workbench" v-if="hasRightBtn">
        <a @click="toWorkbench"><i></i></a>
      </div>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
  <div class="footer">
    <pop-footer/>
  </div>
</div>

</template>
<script>
import {jump, util} from '@utils'
import PopFooter from "../footBar/index"
import { mapState } from 'vuex'

export default {
  name: 'common-framework',
  components: {PopFooter},
  props: {
    name: String,
    hasRightBtn:Boolean
  },
  data () {
    return {
      style: {}
    }
  },
  computed:{
    ...mapState(['userInfo']),
  },
  methods: {
    jumpTolink (name) {
      if (util.isNc(this.userInfo) && name === 'home') {
        util.jumptoNcHomepage()
      } else {
        this.$router.push({
            name
        })
      }
    },
    toWorkbench(){
      if (util.isNc(this.userInfo)) {
        util.jumptoNcPlatform()
      } else {
        jump.workbench()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  $wrap_frame_width: 1100px;
  .common-framework-container {
    background: #fff;
    width: 100%;
    height: 100%;
    .wrap-top {
      min-height: calc(100vh - 120px);
      width: $wrap_frame_width;
      margin: 0 auto;
      padding-top: 20px;
      background-color: #fff;

      .header {
        font-family: MicrosoftYaHei;
        border-bottom: 1px solid #f0f0f0;
        padding-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        .icon-logo{
          display: flex;
          align-items: center;
        }
        img {
          width: 144px;
          height: 48px;
          // display: inline-block;
          margin-right: 10px;
          cursor: pointer;
        }
        .title {
          font-size: 20px;
          color: #333333;
          line-height: 1;
          margin-top:12px;
          // display: inline-block;
          // vertical-align: bottom;
        }
        .link-workbench {
          margin-bottom: -5px;
          i {
            display: inline-block;
            width: 140px;
            height: 20px;
            background: url('~@assets/images/back_workbench.png') no-repeat right bottom;
            background-size: 120px auto;
          }
        }
      }
    }
    .footer {
      background: #f6f6f6;
      padding: 0;
      .label-items {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #666666;
        letter-spacing: 0;
        text-align: center;
      }
    }
  }
</style>
